<template>
    <div class="f-loading" v-show="visible">
        <div class="load-gif"></div>
        <div class="text" v-if="hasText">加载中...</div>
    </div>
</template>

<script>
    export default {
        name: 'f-loading',
        props: {
            visible: {
                type: Boolean,
                default: false
            },
            hasText: {
                type: Boolean,
                default: true
            }
        }
    }
</script>

<style lang="stylus">
    .f-loading
        display: -webkit-box
        display: -webkit-flex
        display: flex
        -webkit-box-pack: center
        -webkit-justify-content: center
        justify-content: center
        -webkit-box-align: center
        -webkit-align-items: center
        align-items: center
        height: 54px
        .load-gif
            width: 24px
            height: 24px
            background: url(//cdn.upin.com/mfanhuan/images/loading32.gif?v=20151126) left top no-repeat;
            background-size: 24px 24px
        .text
            font-size: 14px
            color: #666
            margin-left: 10px
</style>


// WEBPACK FOOTER //
// loading.vue?2d228356